import type { AutomationRuleFlowAction } from '@/services/domain/services/automationRule/flow/types'
import type { AutomationRuleScheduleTimeType } from '@/data/models/domain/services/automationRule/AutomationRuleAction'

export type AutomationRulesPayload = {
  userId: string
  name: string
  phones: string[]
  keywords: string[]
  countries: string[]
  responseType: AutomationRuleLogsResponseType
  scheduleTimeType: AutomationRuleScheduleTimeType
  scheduleTimeParams?: AutomationRuleScheduleTimeParamItem[]
  text?: string
  singleTime: boolean
  actions: AutomationRuleFlowAction[]
  isBeginningOnly: boolean
}

export type AutomationRuleScheduleTimeParamItem = {
  day: string
  enabled: boolean
  schedule: {
    from: string
    to: string
  }[]
}

export type AutomationRuleDto = {
  id: number
  name: string
  isDeleted: boolean
}

export enum AutomationRuleLogsStatus {
  COMPLETED = 'o',
  LOW_BALANCE = 'b',
  ERROR = 'e',
}

export enum AutomationRuleLogsResponseType {
  NONE = '',
  TEXT_MESSAGE = 't',
  TEXT_TO_SPEECH = 's',
  VOICE_BROADCAST = 'v',
}
